import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import NoticeTooltipOnHover from '../../../_utils/notice-tooltip';
import { aboveMinimumDpi } from './dpi-classification';
import { PrintSize } from '../../prop-types';

const DpiNotices = {
  BelowMinimum: 'Poor Resolution',
};

const DpiNoticeTooltips = {
  BelowMinimum:
    'Poor Resolution: Image may print blurry or pixelated, we suggest a smaller sized print',
};

const DpiNotice = ({
  dpi,
  noText,
  tooltipPosition,
  tooltipCSSClasses,
  recommendedPrintSize,
  hideTooltip,
}) => {
  const isAboveMinimum = aboveMinimumDpi(dpi);

  if (isAboveMinimum === undefined || isAboveMinimum) {
    return null;
  }

  const dpiNotice = 'BelowMinimum';
  const dpiCssClass = 'minimum';
  const noticeContent = (
    <div
      className={classNames(
        `dpi-notice text-center dpi-notice-below-${dpiCssClass}`,
        { 'd-flex align-items-center justify-content-center': !noText }
      )}
      aria-label={`${DpiNotices[dpiNotice]} warning`}
      role="tooltip"
      tabIndex="0">
      <span className="dpi-notice__icon" aria-hidden="true">
        <span>!</span>
      </span>
      <span
        className={classNames({ 'd-none': noText })}
        aria-hidden={noText ? 'true' : 'false'}>
        {DpiNotices[dpiNotice]}
      </span>
    </div>
  );

  return hideTooltip ? (
    noticeContent
  ) : (
    <NoticeTooltipOnHover
      tooltipCSSClasses={classNames(
        'dpi-tooltip',
        `dpi-tooltip-below-${dpiCssClass}`,
        tooltipCSSClasses
      )}
      tooltipPosition={tooltipPosition}
      content={`${DpiNoticeTooltips[dpiNotice]}${
        recommendedPrintSize
          ? ` - recommended: ${recommendedPrintSize.title}`
          : ''
      }`}
      show={false}>
      {noticeContent}
    </NoticeTooltipOnHover>
  );
};

DpiNotice.propTypes = {
  dpi: PropTypes.number.isRequired,
  noText: PropTypes.bool,
  tooltipPosition: PropTypes.string,
  tooltipCSSClasses: PropTypes.string,
  hideTooltip: PropTypes.bool,
  recommendedPrintSize: PrintSize,
};

DpiNotice.defaultProps = {
  noText: false,
  tooltipPosition: undefined,
  tooltipCSSClasses: undefined,
  recommendedPrintSize: null,
  hideTooltip: false,
};

export default DpiNotice;
